import type { ParentIssueType } from '@risksmart-app/domain/src/types/consts';

import { ParentTypeEnum } from '../../../generated/graphql';
import type { IssueAssessmentTaxonomyKeys, IssueTaxonomyKeys } from './types';
interface IssueTypeTaxonomyItem {
  taxonomy: IssueTaxonomyKeys;
  assessmentTaxonomy: IssueAssessmentTaxonomyKeys;
}

export const issueTypeTaxonomy: {
  [key in ParentIssueType]: IssueTypeTaxonomyItem;
} = {
  [ParentTypeEnum.Issue]: {
    taxonomy: 'issues',
    assessmentTaxonomy: 'issueAssessment',
  },
  [ParentTypeEnum.IssueRiskEvent]: {
    taxonomy: 'issuesRiskEvents',
    assessmentTaxonomy: 'issueRiskEventAssessment',
  },
  [ParentTypeEnum.IssueBreachLog]: {
    taxonomy: 'issuesBreachLog',
    assessmentTaxonomy: 'issueBreachLogAssessment',
  },
  [ParentTypeEnum.IssueConsumerDuty]: {
    taxonomy: 'issuesConsumerDuty',
    assessmentTaxonomy: 'issueConsumerDutyAssessment',
  },
  [ParentTypeEnum.IssueCustomerTrust]: {
    taxonomy: 'issuesCustomerTrust',
    assessmentTaxonomy: 'issueCustomerTrustAssessment',
  },
  [ParentTypeEnum.IssueGdprBreachLog]: {
    taxonomy: 'issuesGDPRBreachLog',
    assessmentTaxonomy: 'issueGDPRBreachLogAssessment',
  },
  [ParentTypeEnum.IssuePciBreachLog]: {
    taxonomy: 'issuesPCIBreachLog',
    assessmentTaxonomy: 'issuePCIBreachLogAssessment',
  },
  [ParentTypeEnum.IssueSarLog]: {
    taxonomy: 'issuesSARLog',
    assessmentTaxonomy: 'issueSARLogAssessment',
  },
};
